<template>
    <BreadCrumb PageTitle="Modifier une composition" />
    <EditComposition />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditComposition from "@/components/Composition/EditComposition.vue";
  
    export default defineComponent({
      name: "EditCompositionPage",
      components: {
        BreadCrumb,
        EditComposition,
      },
    });
  </script>